module.exports = __webpack_public_path__ + "static/media/2.7f8653a2.png";